import { createRequestTypes } from '@shopee/redux-commons';
import { SearchParams } from '@shopee/search-common-util';

export const FETCH_MART_SEARCH_ITEMS = createRequestTypes(
  'FETCH_MART_SEARCH_ITEMS'
) as {
  REQUESTED: 'FETCH_MART_SEARCH_ITEMS_REQUESTED';
  SUCCESS: 'FETCH_MART_SEARCH_ITEMS_SUCCESS';
  FAILED: 'FETCH_MART_SEARCH_ITEMS_FAILED';
};

export const COPY_MART_SEARCH_RESULT = 'COPY_MART_SEARCH_RESULT';

export const SEARCH_PARAMS_TO_API_PARAMETER_NAMES = {
  keyword: 'keyword',
  facet: 'categoryids',
  brands: 'brandids',
  minPrice: 'price_min',
  maxPrice: 'price_max',
  withDiscount: 'with_discount',
  freeShipping: 'shipping_fee_included',
  wholesale: 'wholesale',
  hasLowestPriceGuarantee: 'filter_lowest_price_guarantee',
  preOrder: 'filter_preorder',
  labelIds: 'label_ids',
  promotionId: 'promotionid',
  entryPoint: 'entry_point',
  pdpL3Category: 'pdp_l3cat',
  warehouseId: 'whs_ids',
} as Record<keyof SearchParams, string>;

export const PRIMITIVE_TYPE_SEARCH_PARAMS = [
  'keyword',
  'entryPoint',
  'pdpL3Category',
  'promotionId',
] as const;

export const BOOLEAN_TYPE_SEARCH_PARAMS = [
  'withDiscount',
  'freeShipping',
  'wholesale',
  'hasLowestPriceGuarantee',
  'preOrder',
] as const;

export const ARRAY_TYPE_SEARCH_PARAMS = [
  'facet',
  'brands',
  'labelIds',
  'warehouseId',
] as const;
